import React from "react";
import { Outlet } from "react-router";

import MyProfileHeadingAndTabs from "../../components/Common/MyProfile/MyProfileHeadingAndTabs";
const UserProfile = () => {
  return (
    <MyProfileHeadingAndTabs
    >
      <Outlet />
    </MyProfileHeadingAndTabs>
  );
};

export default UserProfile;
